import React from "react";
import { Link, withRouter } from "react-router";
import "../assets/SuccessPayment.scss";
import moment from "moment";
import { connect } from "react-redux";
import { getOrderDetails } from "../modules/orders";
import { leftSidebarVisible } from "../../../store/search";
import GiftingImg from "../../Cart/assets/GiftingImg.svg";
import shareImg from "../assets/icons8-share-rounded-32.png"
import facebookImg from "../assets/icons8-facebook.svg"
import instagramImg from "../assets/icons8-instagram.svg"
import { message } from "../../../store/messageBar";
import { isAndroid, isIOS } from "react-device-detect";

const ANDROID_APP_URL = "https://play.google.com/store/apps/details?id=com.xooker.mobile.app&hl=en_US";
const IOS_APP_URL = "https://itunes.apple.com/us/app/xooker/id983457467?mt=8";

class SuccessPaymentView extends React.Component {
  constructor(props) {
    super(props);

    if (isAndroid) {
      window.location = ANDROID_APP_URL;
    } else if (isIOS) {
      window.location = IOS_APP_URL;
    }


    this.state = {
      order: null,
      copied: false,
      order: {},
      cartItems: [],
      charity: {}
    };
    this.copy.bind(this)
  }

  componentWillMount = () => {
    this.props.leftSidebarVisible(false)
    this.setState({ order: this.props.location.state.paymentObj, cartItems: this.props.location.state.cartItems, charity: this.props.location.state.charity });
    }

  copy = () => {
    navigator.clipboard.writeText(window.location.href)
    this.setState({ copied: true })
    this.props.showMessage("Link copied!")
  }

  render() {
   
    const order = this.state.order
    const cartItems = this.state.cartItems
    const charity = this.state.charity
    if (!order) return null

    return (
      <React.Fragment>
        <div className="mb-3 white-container">
          <p>
            <strong>Thank you!</strong>
          </p>
          <p>
            Your order has been placed. Go to <Link to={"/wallet"}>Wallet</Link>
          </p>
        </div>
        Your Order summary
        <div className="white-container">
          {cartItems.map((item, id) => {
            return (
              <div key={item.id}>
                <div className="d-flex m-4">
                  <div className="merchant-image">
                    <img src={item.deal.images[0].url}/>
                  </div>
                  <div className="merchant-info-container">
                    <div className="merchant-info">
                      <div className="merchant-title">{item.offer.title}</div>
                      <div className="merchant-name">{item.deal.merchant.name}</div>
                    </div>
                    <div>{"$" + item.offer.price}</div>
                  </div>
                </div>
                { item.gift ? (
                  item.gift.recipient_name &&
                  <div className="d-flex m-4">
                    <div className="merchant-image gifting-img">
                      <img src={GiftingImg}/>
                    </div>
                    <div className="merchant-info-container">
                      <div className="merchant-info w-25">
                        <div className="py-1">{"Gifted to :"}</div>
                        <div>{"Promo Code :"}</div>
                      </div>
                      <div className="merchant-info w-75">
                        <div className="merchant-title mb-2">
                          <div
                            className="w-100 p-1 px-5 with-border">{item.gift.recipient_name}</div>
                        </div>
                        <div className="merchant-title">
                          <div
                            className="w-100 p-1 px-5 with-border">{item.gift.promo_code}</div>
                        </div>
                      </div>
                    </div>
                  </div>) : ""
                }
              </div>
            );
          })}
          {charity  && (
            <div className="d-flex m-4">
              <div className="w-25"/>
              <div className="sp-donation">
                <span>
                  DONATION: <strong>{charity.name}</strong>
                </span>
                <span>{"$" + order.charity_add_amount}</span>
              </div>
            </div>
          )}

          <div className="d-flex m-4">
            <div className="w-75"/>
            <div className="sp-total">
              <span>
                <strong>Total: </strong>
              </span>
              <span>{"$" + order.total}</span>
            </div>
          </div>
        </div>
        <div className="mt-3">
          <div className="wallet-banner">
            <p>
              <span>No printed vouchers will be accepted.</span>
              <br/>
              <span>
                You <span>MUST</span> use the FREE Xooker app to redeem all purchases.
              </span>
            </p>
            <p>
              <span>
                Certificates purchased will appear in your digital wallet under the <span>'Gift Certificates'</span> tab in the
                Xooker app.
              </span>
            </p>
          </div>
        </div>
        <div className="white-container mt-3 d-flex align-items-center">
          <p className="w-50">
            {" "}
            <span className="media-header"> Show your friends your great deal!</span> <br/>{" "}
            <div className="media-share-container">
              <img src={shareImg} onClick={this.copy} className="share-img"/>
              <Link to={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
                    target={"_blank"}>
                <img src={facebookImg} className="share-img"/>
              </Link>{" "}
              <Link to={"https://www.instagram.com/xooker/"} target={"_blank"}>
                <img src={instagramImg} className="share-img"/>
              </Link>
            </div>
          </p>
          <div className="vertical-divider"/>
          <p className="w-50">
            {" "}
            <span className="media-header"> Be sure to download the app to redeem your certificate.</span>
            <br/>{" "}
            <div className="media-content">
              <Link to={ANDROID_APP_URL}
                    target={"_blank"}>
                <span className={"google-play_btn"}> </span>
              </Link>{" "}
              &nbsp; &nbsp;{" "}
              <Link to={IOS_APP_URL} target={"_blank"}>
                <span className={"app-store_btn"}> </span>
              </Link>
            </div>
          </p>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    order: state.orderDetails
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOrderDetails: (uuid) => dispatch(getOrderDetails(uuid)),
    leftSidebarVisible: (val) => dispatch(leftSidebarVisible(val)),
    showMessage: (text) => dispatch(message(text))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuccessPaymentView)



// WEBPACK FOOTER //
// ./src/routes/SuccessPayment/components/SuccessPaymentView.js